import * as helios from "@hyperionbt/helios";
import { DisplayableError } from "kreate-common/modules/displayable-error";
import { useModalPromises } from "kreate-common/modules/kreate-ui/components/Modal/hoc/withModalPromises";

import ModalConnectWallet from "..";

import { useCardanoWalletApi } from "@/modules/cardano-wallet";

export function useModalTrigger$ModalConnectWallet() {
  const { showModal } = useModalPromises();
  const wallet = useCardanoWalletApi();

  const openModal = async () =>
    await showModal<helios.Cip30Handle>(({ resolve, reject }) => (
      <ModalConnectWallet
        open
        onSuccess={(cip30Handle) => resolve(cip30Handle)}
        onCancel={() => reject(null)}
      />
    ));

  const getCip30WalletOrOpenModal = async () => {
    switch (wallet.type) {
      case "ready":
        return wallet.cip30Wallet;
      case "disconnected": {
        const cip30Handle = await openModal();
        return new helios.Cip30Wallet(cip30Handle);
      }
      default:
        throw new DisplayableError({ title: "Wallet is not ready" });
    }
  };

  return { openModal, getCip30WalletOrOpenModal };
}
